import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=7c7adbfb&scoped=true"
import script from "./AppMain.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppMain.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppMain.vue?vue&type=style&index=0&id=7c7adbfb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7adbfb",
  null
  
)

export default component.exports